module.exports = __webpack_public_path__ + "static/media/key.128e9354.svg";